/**
 * Charge un script JS une seule fois et retourne une promesse.
 */
export const dynamicallyLoadedScripts: Record<string, boolean> = {};

export const loadJS = (path: string) => {
    return new Promise((resolve, reject) => {
        const alreadyTriedToLoadIt = dynamicallyLoadedScripts[path];
        if (!alreadyTriedToLoadIt) {
            const scriptShellElement = document.createElement('script');
            scriptShellElement.onload = resolve;
            scriptShellElement.onerror = reject;
            scriptShellElement.src = path;
            dynamicallyLoadedScripts[path] = true;
            return document.head.appendChild(scriptShellElement);
        }

        return resolve(null);
    });
};

export const loadOnetrustJS = (path: string) => {
    return new Promise((resolve, reject) => {
        const alreadyTriedToLoadIt = dynamicallyLoadedScripts[path];
        if (!alreadyTriedToLoadIt) {
            const scriptShellElement = document.createElement('script');
            scriptShellElement.type = 'text/javascript';
            scriptShellElement.src = path;
            dynamicallyLoadedScripts[path] = true;
            scriptShellElement.dataset.domainScript = globalThis.VITE_COOKIE_KEY ?? '';
            scriptShellElement.dataset.documentLanguage = 'true';
            scriptShellElement.onload = resolve;
            scriptShellElement.onerror = reject;
            return document.head.appendChild(scriptShellElement);
        }

        return resolve(null);
    });
};
